import moment from "moment";
import { difference, isNumber } from "lodash";

export interface WeekYear {
  Week: number;
  Year: number;
}

export interface WeekYear1 {
  week: number;
  year: number;
}

export function dateToWeekYear(date: Date) {
  const m = moment.utc(date);

  return {
    Week: m.isoWeek(),
    Year: m.isoWeekYear()
  };
}

export function dateToWeekYear1(date: Date) {
  const m = moment.utc(date);

  return {
    week: m.isoWeek(),
    year: m.isoWeekYear()
  };
}

export function weekYearToDate(weekYear: WeekYear) {
  return weekYearToMoment(weekYear).toDate();
}

export function weekYearToDate1(weekYear: WeekYear1) {
  return weekYearToMoment1(weekYear).toDate();
}

export function weekYearToDateLocal(weekYear: WeekYear) {
  return weekYearToMomentLocal(weekYear).toDate();
}

export function weekYearToMoment(weekYear: WeekYear) {
  return moment
    .utc()
    .isoWeekYear(weekYear.Year)
    .isoWeek(weekYear.Week)
    .startOf("isoWeek");
}

export function weekYearToMoment1(weekYear: WeekYear1) {
  return moment
    .utc()
    .isoWeekYear(weekYear.year)
    .isoWeek(weekYear.week)
    .startOf("isoWeek");
}

export function weekYearToMomentLocal(weekYear: WeekYear) {
  return moment().isoWeekYear(weekYear.Year).isoWeek(weekYear.Week).startOf("isoWeek");
}

export function dateToWeek(date: Date) {
  return moment.utc(date).isoWeek();
}

export function dateToYear(date: Date) {
  return moment.utc(date).isoWeekYear();
}

export function isWeekYear(val: any): val is WeekYear {
  return (
    typeof val === "object" &&
    isNumber(val.Week) &&
    isNumber(val.Year) &&
    isBetween(val.Week, 1, 53) &&
    isBetween(val.Year, 1900, 2100)
  );
}

function isBetween(val: number, from: number, to: number) {
  return val >= from && val <= to;
}

export function isSame(v1: WeekYear, v2: WeekYear) {
  return v1 && v2 && v1.Week === v2.Week && v1.Year === v2.Year;
}

export function weekDiff(arg1: Date[], arg2: Date[]) {
  const values1 = arg1.map((x) => x.valueOf());
  const values2 = arg2.map((x) => x.valueOf());

  const diff = difference(values1, values2);

  return diff.map((x) => new Date(x));
}
